const FIT_AUTO_CLOSE_SELECTOR = 'details[data-auto-close-details][open]';
const FIT_MOBILE_MEDIA_QUERY = '(max-width: 749px)';

class FitAutoCloseDetailsController {
  constructor(root = document, mediaQuery = window.matchMedia(FIT_MOBILE_MEDIA_QUERY)) {
    this.root = root;
    this.mediaQuery = mediaQuery;
    this.isMobile = mediaQuery.matches;
    this.abortController = new AbortController();
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
  }

  connect() {
    const options = { passive: true, signal: this.abortController.signal };
    this.root.addEventListener('click', this.handleDocumentClick, options);
    this.mediaQuery.addEventListener('change', this.handleViewportChange, {
      signal: this.abortController.signal,
    });
  }

  disconnect() {
    this.abortController.abort();
  }

  currentViewport() {
    return this.isMobile ? 'mobile' : 'desktop';
  }

  shouldAutoClose(detailsElement) {
    const config = (detailsElement.getAttribute('data-auto-close-details') || '').toLowerCase();
    return config.includes(this.currentViewport());
  }

  handleViewportChange(event) {
    this.isMobile = event.matches;
  }

  handleDocumentClick(event) {
    const openDetails = this.root.querySelectorAll(FIT_AUTO_CLOSE_SELECTOR);
    if (openDetails.length === 0) return;

    const target = event.target;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];

    for (const detailsElement of openDetails) {
      if (!(detailsElement instanceof HTMLDetailsElement)) continue;
      if (!this.shouldAutoClose(detailsElement)) continue;

      const clickedInsideByContains = target instanceof Node && detailsElement.contains(target);
      const clickedInsideByPath = path.includes(detailsElement);
      if (clickedInsideByContains || clickedInsideByPath) continue;

      requestAnimationFrame(() => detailsElement.removeAttribute('open'));
    }
  }
}

(function initializeFitAutoCloseDetailsController() {
  if (window.__fitAutoCloseDetailsController) {
    window.__fitAutoCloseDetailsController.disconnect();
  }

  const controller = new FitAutoCloseDetailsController();
  controller.connect();
  window.__fitAutoCloseDetailsController = controller;
})();
